import {
  ExchangeTaskTargets,
  ExchangeScanTaskTimeUnit,
  ExclusionGridItem,
  ExchangeTaskScanFileTypes,
  ExchangeScanTaskActions,
} from './gzExchangeScanTask/types';

export interface ExchangeScanGeneralSettings {
  name: string;
  useStopScan: boolean;
  interval?: string;
  occurrence?: ExchangeScanTaskTimeUnit;
}

export interface ExchangeScanTargetSettings {
  targetType: ExchangeTaskTargets;
  scanEmails: boolean;
  scanContacts: boolean;
  scanTasks: boolean;
  scanAppointments: boolean;
  scanPostItems: boolean;
  scanOnlyUnreadEmails: boolean;
  scanOnlyItemsWithAttachments: boolean;
  scanOnlyRecentReceivedEnabled: boolean;
  scanOnlyRecentReceivedStep?: string;
  scanOnlyRecentReceivedStepType?: ExchangeScanTaskTimeUnit;
  exclusionsEnabled: boolean | null;
  exclusions?: Array<ExclusionGridItem>;
}

export interface ExchangeScanOptions {
  scanMode: ExchangeTaskScanFileTypes;
  maximumSizeEnabled: boolean;
  maximumSize: string;
  maximumDepthEnabled: boolean;
  maximumDepth: string | null;
  scanPUA: boolean;
  extensions?: Array<string>;
}

export interface ExchangeScanAction {
  action: ExchangeScanTaskActions;
  then: ExchangeScanTaskActions;
}

export interface ExchangeScanActions {
  infected: ExchangeScanAction;
  suspected: ExchangeScanAction;
  unscannable: ExchangeScanAction;
}

export interface ExchangeScanTaskSpecifics {
  general: ExchangeScanGeneralSettings;
  target: ExchangeScanTargetSettings;
  options: ExchangeScanOptions;
  actions: ExchangeScanActions;
}

export const DEFAULT_ARCHIVE_MAXIMUM_DEPTH = null;
export const DEFAULT_ATTACHMENT_MAX_SIZE = '3';
